import { useUiImage } from '@/ui/art/uiArt';
import styles from './Postcard.module.css';

/**
 * One of Granny's postcards (S10a, gaps B7): the painted picture on top, the message on the card's back paper
 * below it (`postcard_back`). Without art it reads as the plain lined card it used to be.
 */
export function Postcard({ image, title, body }: { image?: string; title?: string; body: string }) {
  const front = useUiImage(image);
  const back = useUiImage('postcard_back');
  return (
    <article className={styles.card}>
      {front && <img className={styles.front} src={front} alt="" draggable={false} />}
      <div className={styles.back} style={back ? { backgroundImage: `url(${back})` } : undefined}>
        {title && <h3>{title}</h3>}
        <p>{body}</p>
      </div>
    </article>
  );
}
